export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fc2672177b476c5a93ce548a50425a47a31488919&name=fetchTypeahead!'